export default {
  header: {
    navigation: {
      about: "Nous connaître",
      resources: "Ressources",
      directory: "Annuaire Artisans RGE"
    },
    menu: "Menu"
  },
  home: {
    hero: {
      title1: "Devenez Ambassadeur chez",
      title2: "projetsolaire.",
      subtitle: "Participez à la Révolution Solaire et Gagnez en Même Temps!",
      button: "Commencer",
      "learn-more": "En savoir plus",
      badge: "Accélerons la révolution solaire, ensemble.",
      "badge-link": "En savoir plus sur nous",
      "current-title": "Parrainez. Gagnez 500 €.<br/>Sauvez la planète.",
      "current-description": "Soyez rémunéré pour partager les bienfaits de l'énergie solaire à vos voisins, proches et collègues. Et aidez-nous à changer le monde.",
      "image-alt": "Image d'illustration du programme d'ambassadeur"
    },
    why: {
      whyup: "Pourquoi ?",
      title: "Pourquoi devenir un ambassadeur de l'énergie solaire ?",
      reason1: {
        title: "Impact Environnemental :",
        description:
          "Contribuez à la lutte contre le changement climatique en promouvant une source d'énergie propre et renouvelable.",
      },
      reason2: {
        title: "Revenus Supplémentaires :",
        description:
          "Gagnez de l'argent en recommandant nos services et en aidant les propriétaires à passer à l'énergie solaire.",
      },
      reason3: {
        title: "Formation et Soutien :",
        description:
          "Bénéficiez d'une formation complète et d'un soutien continu pour réussir en tant qu'ambassadeur.",
      },
      reason4: {
        title: "Flexibilité :",
        description:
          "Travailler à votre rythme, où vous le souhaitez, en fonction de vos horaires et de votre style de vie.",
      },
      caption:
        '"J’ai déjà parrainé deux amis et j’ai pu les accompagner dans leur parcours vers l’autoconsommation. Leurs installations se sont déroulées rapidement, ils sont ravis. Tout le monde est gagnant !"',
    },
    how: {
      title: "Comment se lancer ?",
      description: "Voici les étapes des ambassadeurs de chez projet solaire.",
      step1: {
        title: "Candidature",
        description: "Déposez votre candidature en quelques clics.",
      },
      step2: {
        title: "Parrainage",
        description:
          "Commencez à parrainer vos contacts souhaitant passer au photovoltaïque.",
      },
      step3: {
        title: "Récompense",
        description:
          "Percevez 500 euros pour chaque devis que vous ferez signer.",
      },
    },
    tools: {
      title: "Nos outils",
      description:
        "Nous vous donnons accès à des outils pour vous faciliter la tâche.",
      tool1: {
        title: "Formation :",
        description:
          "Bénéficiez d'une formation complète pour pouvoir vous lancer dans l’aventure solaire en toute sérénité ! ",
      },
      tool2: {
        title: "Accompagnement :",
        description:
          "Vous recevrez du matériel marketing pour vous aider à atteindre vos objectifs. ",
      },
    },
    faq: {
      title: "Questions Fréquentes (FAQ) :",
      q1: {
        question: "Comment fonctionne le programme d'ambassadeur ?",
        respond:
          "Notre programme d'ambassadeur vous récompense chaque fois que vous recommandez un client qui signe un devis avec nous. Plus vous recommandez, plus vous gagnez.",
      },
      q2: {
        question: "Y a-t-il des coûts associés à devenir ambassadeur ?",
        respond:
          "Non, l'inscription en tant qu'ambassadeur est entièrement gratuite.",
      },

      q3: {
        question:
          "Ai-je besoin de connaissances préalables en énergie solaire ?",
        respond:
          "Non, nous fournissons une formation complète pour vous préparer à promouvoir nos services.",
      },
    },
    cta: {
      title: "Parrainez aujourd'hui pour recevoir plusieurs devis d'artisans",
      description:
        "C'est aussi simple que ça de contribuer à éliminer des tonnes de CO2 de l'atmosphère. Et plus vous parrainez de personnes, plus vous avez de chances de recevoir 500 € par parrainage, versés directement sur votre compte bancaire.",
      button: "Je parraine !",
    },
    banner: {
      paragraph:
        "Parrainez aujourd'hui pour recevoir plusieurs devis d'artisans",
      description:
        "C'est aussi simple que ça de contribuer à éliminer des tonnes de CO2 de l'atmosphère. Et plus vous parrainez de personnes, plus vous avez de chances de recevoir 500 € par parrainage, versés directement sur votre compte bancaire.",
      button: "Je parraine !",
    },
  },
 "sign-in": {
    title: "Bienvenu, aidez nous à croitre le photovoltaïque en France !",
  },
  faq: {
    title:
      "Nos réponses à vos questions concernant le bouche-à-oreille rémunéré",
  },
}
